/**
 * @link      https://karmabunny.com.au
 * @copyright Copyright (c) 2023 Karmabunny
 */
import { Event } from "../types";
import { API } from "./base";


const api = new API();

/**
 * Fetch 'internal' events.
 *
 * These are sometimes bookable.
 */
export async function getParkEvents(entity_uid?: string) {
    entity_uid ??= api.config.base_entity_uid;

    const res = await api.call({
        method: 'GET',
        endpoint: `/event/${entity_uid}/events`,
        query: { host_type: 'internal' },
    })

    return res.items as Event[];
}


/**
 * Fetch 'external' events.
 *
 * These are never bookable.
 */
export async function getLocalEvents(entity_uid?: string) {
    entity_uid ??= api.config.base_entity_uid;

    const res = await api.call({
        method: 'GET',
        endpoint: `/event/${entity_uid}/events`,
        query: { host_type: 'external' },
    })

    return res.items as Event[];
}


/**
 * Hits `#[Route('{uid}/events')]` in the Explore controller in TheyStay/API returning
 * the details for a *single* event based on the provided event_uid. Optionally provide a
 * date_start param for finer control over the results returned in search_schedule
 */
export async function getEvent(event_uid: string, date_start?: string, entity_uid?: string) {
    entity_uid ??= api.config.base_entity_uid;
    const dateStartQuery = date_start ? { date_start: date_start } : {};

    const res = await api.call({
        method: 'GET',
        endpoint: `/event/${entity_uid}/events/${event_uid}`,
        query: dateStartQuery,
    })

    return res as Event;
}

